import { createInitialStates, createResourceNames, createSequenceTypes, getErrorData } from '../helpers'
import { INITIAL_STATE_REDUCERS } from '../constants'

const RESOURCES = [
  'checkoutRequestsByEntityIdGet',
  'checkoutRequestsByIdGet',
  'checkoutRequestsCancelLinkPut',
  'checkoutRequestsMonthlyInstallmentsGet',
  'checkoutRequestsNewLinkPost',
  'checkoutRequestsSendEmailPut',
  'entityByEntityIdGet'
]
const R = createResourceNames(RESOURCES)
export enum SequenceTypeNames {
  'CHECKOUT_REQUESTS_BY_ENTITY_ID_GET' = 'CHECKOUT_REQUESTS_BY_ENTITY_ID_GET',
  'CHECKOUT_REQUESTS_BY_ID_GET' = 'CHECKOUT_REQUESTS_BY_ID_GET',
  'CHECKOUT_REQUESTS_CANCEL_LINK_PUT' = 'CHECKOUT_REQUESTS_CANCEL_LINK_PUT',
  'CHECKOUT_REQUESTS_MONTHLY_INSTALLMENTS_GET' = 'CHECKOUT_REQUESTS_MONTHLY_INSTALLMENTS_GET',
  'CHECKOUT_REQUESTS_NEW_LINK_POST' = 'CHECKOUT_REQUESTS_NEW_LINK_POST',
  'CHECKOUT_REQUESTS_SEND_EMAIL_PUT' = 'CHECKOUT_REQUESTS_SEND_EMAIL_PUT',
  'ENTITY_BY_ENTITY_ID_GET' = 'ENTITY_BY_ENTITY_ID_GET'
}
const TYPES = createSequenceTypes(Object.values(SequenceTypeNames))
export const INITIAL_STATE = {
  ...createInitialStates(RESOURCES, INITIAL_STATE_REDUCERS)
}

const reducers = {
  // CHECKOUT REQUESTS BY ENTITY ID GET ················································································
  [TYPES.CHECKOUT_REQUESTS_BY_ENTITY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.checkoutRequestsByEntityIdGet]: {
        data: [],
        error: {},
        isLoading: true
      }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_BY_ENTITY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const { data: dataPayload, entity } = payload
    const data = [{ ...dataPayload, ...entity }]
    return {
      ...state,
      [R.checkoutRequestsByEntityIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_BY_ENTITY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.checkoutRequestsByEntityIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_BY_ENTITY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.checkoutRequestsByEntityIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // ENTITY BY ENTITY ID GET ················································································
  [TYPES.ENTITY_BY_ENTITY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.entityByEntityIdGet]: {
        data: {},
        error: {},
        isLoading: true
      }
    }
  },
  [TYPES.ENTITY_BY_ENTITY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const { data: dataPayload, entity } = payload
    const data = { ...dataPayload, ...entity }
    return {
      ...state,
      [R.entityByEntityIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.ENTITY_BY_ENTITY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.entityByEntityIdGet]: { data: {}, error, isLoading: false }
    }
  },
  [TYPES.ENTITY_BY_ENTITY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.entityByEntityIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // CHECKOUT REQUESTS BY ID GET ·······················································································
  [TYPES.CHECKOUT_REQUESTS_BY_ID_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.checkoutRequestsByIdGet]: {
        data: [],
        error: {},
        isLoading: true
      }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_BY_ID_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const data = { responseStatus: payload.status, ...payload.data }
    return {
      ...state,
      [R.checkoutRequestsByIdGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_BY_ID_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.checkoutRequestsByIdGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_BY_ID_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.checkoutRequestsByIdGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // CHECKOUT REQUESTS CANCEL LINK PUT ·················································································
  [TYPES.CHECKOUT_REQUESTS_CANCEL_LINK_PUT_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.checkoutRequestsCancelLinkPut]: {
        data: [],
        error: {},
        isLoading: true
      }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_CANCEL_LINK_PUT_SUCCESSFUL]: (state: any, payload: any) => {
    const data = { responseStatus: payload.status, ...payload.data }
    return {
      ...state,
      [R.checkoutRequestsCancelLinkPut]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_CANCEL_LINK_PUT_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.checkoutRequestsCancelLinkPut]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_CANCEL_LINK_PUT_RESET]: (state: any) => {
    const RESOURCE_NAME = R.checkoutRequestsCancelLinkPut
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // CHECKOUT REQUESTS MONTHLY INSTALLMENTS GET ········································································
  [TYPES.CHECKOUT_REQUESTS_MONTHLY_INSTALLMENTS_GET_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.checkoutRequestsMonthlyInstallmentsGet]: {
        data: [],
        error: {},
        isLoading: true
      }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_MONTHLY_INSTALLMENTS_GET_SUCCESSFUL]: (state: any, payload: any) => {
    const { data: dataPayload } = payload
    const data = [...dataPayload]
    return {
      ...state,
      [R.checkoutRequestsMonthlyInstallmentsGet]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_MONTHLY_INSTALLMENTS_GET_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.checkoutRequestsMonthlyInstallmentsGet]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_MONTHLY_INSTALLMENTS_GET_RESET]: (state: any) => {
    const RESOURCE_NAME = R.checkoutRequestsMonthlyInstallmentsGet
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // CHECKOUT REQUESTS NEW LINK POST ···················································································
  [TYPES.CHECKOUT_REQUESTS_NEW_LINK_POST_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.checkoutRequestsNewLinkPost]: {
        data: [],
        error: {},
        isLoading: true
      }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_NEW_LINK_POST_SUCCESSFUL]: (state: any, payload: any) => {
    const data = { responseStatus: payload.status, ...payload.data }
    return {
      ...state,
      [R.checkoutRequestsNewLinkPost]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_NEW_LINK_POST_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.checkoutRequestsNewLinkPost]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_NEW_LINK_POST_RESET]: (state: any) => {
    const RESOURCE_NAME = R.checkoutRequestsNewLinkPost
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  },

  // CHECKOUT REQUESTS SEND EMAIL PUT ··················································································
  [TYPES.CHECKOUT_REQUESTS_SEND_EMAIL_PUT_REQUESTED]: (state: any) => {
    return {
      ...state,
      [R.checkoutRequestsSendEmailPut]: {
        data: [],
        error: {},
        isLoading: true
      }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_SEND_EMAIL_PUT_SUCCESSFUL]: (state: any, payload: any) => {
    const data = { responseStatus: payload.status, ...payload.data }
    return {
      ...state,
      [R.checkoutRequestsSendEmailPut]: { data, error: {}, isLoading: false }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_SEND_EMAIL_PUT_FAILED]: (state: any, payload: any) => {
    const error = getErrorData(payload)
    return {
      ...state,
      [R.checkoutRequestsSendEmailPut]: { data: [], error, isLoading: false }
    }
  },
  [TYPES.CHECKOUT_REQUESTS_SEND_EMAIL_PUT_RESET]: (state: any) => {
    const RESOURCE_NAME = R.checkoutRequestsSendEmailPut
    return { ...state, [RESOURCE_NAME]: { ...INITIAL_STATE[RESOURCE_NAME] } }
  }
}

export default reducers
